module.exports = __webpack_public_path__ + "assets/img/18_1827_big.eb131127.jpg";